import React from 'react';
export function MenuDownIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.991 15.005a1 1 0 01-.709-.295L8.291 11.7a1 1 0 011.418-1.41L12 12.591l2.3-2.286a1 1 0 111.41 1.418l-3.01 2.991a1 1 0 01-.709.291z"
  }));
}